import './Footer.css'
import Facebook from './images/4552607_facebook_logo_icon.png';
import Insta from './images/2959748_instagram_photo_share_icon.png';
import Youtube from './images/211928_social_youtube_icon.png';
import { Link } from 'react-router-dom';


export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <div className='footer-container'>
      <nav id='footer-nav'>
        <div className="hide-on-home-page"><p id='copy'>&copy; Copyright {currentYear} Aethel Music</p></div>
        
        <div className='centre-content'>
        <div className="footer-icons">
          <a href='https://www.facebook.com/aethelmelodies'><span><img src={Facebook} className='SMlogo' id='facebook' alt='Facebook Logo'></img></span></a>
          <a href='https://www.youtube.com/@aethel1234'>
            <span><img src={Youtube} className='SMlogo' alt='Youtube Logo' id="youtube"></img></span>
          </a>
          <a href='https://www.instagram.com/aethelmusic/'>
            <span><img src={Insta} className='SMlogo' id="insta" alt='Insta Logo'></img></span></a>
        </div>
        <div id='Jakamum'><p>Website by &#9753;<span style={{fontFamily:'Gwendolyn', fontSize:'1.25rem'}}>Jakamum</span> &#10087; </p></div></div>

        <div className='conditions'>
          <Link to="/privacy"><p>Policies</p></Link>
         
        </div>
      </nav>
    </div>

  );
}      